module.exports = __webpack_public_path__ + "img/critair.3ecef5d8.svg";